import request from '@/utils/request';

/**
 * 商户入驻申请 —— 全部是无需登录的公开接口（api/publicly/**）。
 * 申请人此时还没有账号，任何要 token 的接口都不能用。
 */

/** 图片验证码：返回 { key, code }，code 是 base64 图片，key 提交时回传用于校验 */
export function settleCaptchaApi() {
  return request({
    url: '/publicly/validate/code/get',
    method: 'get'
  });
}

/** 发送手机验证码 */
export function settleSendSmsApi(phone) {
  return request({
    url: '/publicly/shop/apply/sendSmsCode',
    method: 'get',
    params: {
      phone: phone
    }
  });
}

/** 提交入驻申请 */
export function settleSubmitApi(data) {
  return request({
    url: '/publicly/shop/apply/submit',
    method: 'post',
    data: data
  });
}

/** 商户入驻协议正文 */
export function settleAgreementApi() {
  return request({
    url: '/publicly/shop/apply/agreement/settle',
    method: 'get'
  });
}

/** 隐私保护政策正文 */
export function settlePrivacyApi() {
  return request({
    url: '/publicly/shop/apply/agreement/privacy',
    method: 'get'
  });
}